// src/pages/UnauthorizedPage.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function safeString(v) {
  return typeof v === "string" ? v : v == null ? "" : String(v);
}

function normalizeRole(v) {
  const r = safeString(v).trim().toLowerCase();

  if (r === "tech") return "technician";
  if (r === "service_manager") return "manager";
  if (r === "store_manager") return "manager";

  return r;
}

export function landingForRole(role, auth) {
  const mode = auth?.mode === "platform" ? "platform" : "store";
  const isPlatformUser = !!auth?.isPlatformUser;

  if (mode === "platform" && isPlatformUser) return "/platform/admin";

  const r = normalizeRole(role);

  if (r === "advisor") return "/advisor-log";
  if (r === "parts") return "/parts-manager";
  if (r === "staff") return "/parts";
  if (r === "foreman") return "/shop-foreman";
  if (r === "technician") return "/tech";

  return "/dashboard";
}

export default function UnauthorizedPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const auth = useAuth();

  const role =
    auth?.membership?.role ||
    auth?.user?.role ||
    auth?.user?.appRole ||
    auth?.role ||
    "";

  const from = safeString(loc?.state?.from || "").trim();
  const fallback = landingForRole(role, auth);

  function goBackSafely() {
    if (window.history.length > 1) {
      nav(-1);
      return;
    }

    nav(fallback, { replace: true });
  }

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "grid",
        placeItems: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          width: "min(520px, 92vw)",
          border: "1px solid #e5e7eb",
          borderRadius: 16,
          background: "#ffffff",
          padding: 20,
          boxShadow: "0 10px 28px rgba(15,23,42,0.08)",
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 900,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "#991b1b",
          }}
        >
          Access restricted
        </div>

        <h2 style={{ margin: "8px 0 0", color: "#111827" }}>Unauthorized</h2>

        <p style={{ marginTop: 8, color: "#4b5563", lineHeight: 1.45 }}>
          You don’t have access to that page.
        </p>

        {from ? (
          <div
            style={{
              marginTop: 10,
              padding: "8px 10px",
              borderRadius: 10,
              background: "#f8fafc",
              border: "1px solid #e5e7eb",
              color: "#64748b",
              fontSize: 12,
              wordBreak: "break-word",
            }}
          >
            Attempted page: <b style={{ color: "#111827" }}>{from}</b>
          </div>
        ) : null}

        <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
          <button
            type="button"
            onClick={goBackSafely}
            style={{
              border: "1px solid #111827",
              background: "#111827",
              color: "#ffffff",
              borderRadius: 10,
              padding: "10px 14px",
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            Go Back
          </button>

          <button
            type="button"
            onClick={() => nav(fallback, { replace: true })}
            style={{
              border: "1px solid #d1d5db",
              background: "#ffffff",
              color: "#111827",
              borderRadius: 10,
              padding: "10px 14px",
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            Go to My Home
          </button>
        </div>
      </div>
    </div>
  );
}
